import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { id: "modais" }
const _hoisted_2 = {
  class: "modal fade modal-md",
  id: "ModalDownloadFiltro",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "ModalDownloadFiltro",
  "aria-hidden": "true",
  "data-bs-keyboard": "false",
  "data-bs-backdrop": "static"
}
const _hoisted_3 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_4 = {
  class: "modal-content",
  style: {"border-radius":"15px"}
}
const _hoisted_5 = { class: "modal-header p-5" }
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex gap-4 p-0 align-items-center\"><div style=\"background:rgb(236, 236, 236);\" class=\"p-3 rounded\"><i style=\"height:fit-content;width:fit-content;font-size:18px;color:#203972 !important;\" class=\"m-0 fas fa-pencil-alt\"></i></div><div><p class=\"m-0 subtitulo cor_texto_1\">Baixar Planilha</p><p class=\"m-0 legenda text-muted\">Baixe a planilha de filtros do sistema</p></div></div>", 1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("svg", {
  height: "2em",
  fill: "#afb7bd",
  widxmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 320 512"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M310.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L160 210.7 54.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L114.7 256 9.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 301.3 265.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L205.3 256 310.6 150.6z" })
], -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  class: "modal-body background_2",
  id: "modalBody"
}
const _hoisted_10 = {
  class: "bg-white p-5",
  style: {"border-radius":"1rem"}
}
const _hoisted_11 = { class: "d-flex flex-column mb-4" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "texto mb-1" }, "Marcas Veículo", -1)
const _hoisted_13 = { class: "d-flex flex-column mb-4" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "texto mb-1" }, "Modelo Veículo", -1)
const _hoisted_15 = { class: "d-flex flex-column mb-4" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "texto mb-1" }, "Marcas Filtro", -1)
const _hoisted_17 = { class: "d-flex flex-column mb-4" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "texto mb-1" }, [
  /*#__PURE__*/_createTextVNode("Tipo Veículo "),
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, "*")
], -1)
const _hoisted_19 = { class: "d-flex flex-column mb-4" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "texto mb-1" }, "Fipe", -1)
const _hoisted_21 = { class: "d-flex flex-column mb-4" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "texto mb-1" }, "Ano", -1)
const _hoisted_23 = { class: "d-flex gap-3" }
const _hoisted_24 = {
  key: 0,
  class: "text-danger",
  style: {"font-size":"13px","display":"block"}
}
const _hoisted_25 = { class: "modal-footer d-flex flex-nowrap justify-content-end align-items-center p-5 gap-4" }
const _hoisted_26 = ["disabled"]
const _hoisted_27 = {
  key: 0,
  style: {"font-size":"medium","height":"18px","width":"18px"},
  class: "spinner-border",
  role: "status"
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Loading...", -1)
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  height: "2em",
  fill: "white",
  viewBox: "0 0 512 512"
}
const _hoisted_31 = /*#__PURE__*/_createElementVNode("path", { d: "M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V274.7l-73.4-73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0l128-128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L288 274.7V32zM64 352c-35.3 0-64 28.7-64 64v32c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V416c0-35.3-28.7-64-64-64H346.5l-45.3 45.3c-25 25-65.5 25-90.5 0L165.5 352H64zm368 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48z" }, null, -1)
const _hoisted_32 = [
  _hoisted_31
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", {
              class: "cursor-pointer",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (!_ctx.loadDownload && _ctx.closeModal())),
              "aria-label": "Close"
            }, _hoisted_8)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _createVNode(_component_el_select, {
                  modelValue: _ctx.formFiltro.marcaVeiculo,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formFiltro.marcaVeiculo) = $event)),
                  multiple: "",
                  filterable: "",
                  placeholder: "Selecione uma ou mais marcas",
                  clearable: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrayMarcas, (marca, indice) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: indice,
                        label: marca,
                        value: marca
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", null, _toDisplayString(marca), 1)
                        ]),
                        _: 2
                      }, 1032, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _createVNode(_component_el_input, {
                  modelValue: _ctx.formFiltro.modelo,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formFiltro.modelo) = $event)),
                  placeholder: "Modelo",
                  clearable: "",
                  type: "text",
                  class: "mb-2"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _hoisted_16,
                _createVNode(_component_el_select, {
                  modelValue: _ctx.formFiltro.marcaFiltro,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formFiltro.marcaFiltro) = $event)),
                  multiple: "",
                  filterable: "",
                  placeholder: "Selecione uma ou mais marcas",
                  clearable: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrayMarcasFiltro, ({ nome, id_marca_produto }, key) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: key,
                        label: `${nome}`,
                        value: `${id_marca_produto}`,
                        class: "texto"
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _hoisted_18,
                _createVNode(_component_el_select, {
                  modelValue: _ctx.formFiltro.tipo,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formFiltro.tipo) = $event)),
                  filterable: "",
                  placeholder: "Selecione o tipo de veículo",
                  clearable: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tipos, (tipo, key) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: key,
                        label: `${tipo}`,
                        value: `${tipo}`,
                        class: "texto"
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _hoisted_20,
                _createVNode(_component_el_input, {
                  modelValue: _ctx.formFiltro.fipe,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formFiltro.fipe) = $event)),
                  placeholder: "Fipe",
                  clearable: "",
                  type: "text",
                  class: "mb-2"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _hoisted_22,
                _createElementVNode("div", _hoisted_23, [
                  _createVNode(_component_el_input, {
                    onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.verificaAno())),
                    onInput: _ctx.aplicaMascara,
                    style: {"border":"1.5px solid #DBDBDB","border-radius":"4px"},
                    placeholder: "Inicial...",
                    modelValue: _ctx.formFiltro.anoInicial,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formFiltro.anoInicial) = $event))
                  }, null, 8, ["onInput", "modelValue"]),
                  _createVNode(_component_el_input, {
                    onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.verificaAno())),
                    onInput: _ctx.aplicaMascara,
                    style: {"border":"1.5px solid #DBDBDB","border-radius":"4px"},
                    placeholder: "Final...",
                    modelValue: _ctx.formFiltro.anoFinal,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formFiltro.anoFinal) = $event))
                  }, null, 8, ["onInput", "modelValue"])
                ]),
                (_ctx.mensagem)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(_ctx.mensagem), 1))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.gerarRelatorio())),
              disabled: _ctx.loadDownload,
              style: {"height":"fit-content","white-space":"nowrap"},
              class: "btn btn-danger d-flex flex-row gap-3 px-5 py-2 justify-content-center align-items-center m-0 texto"
            }, [
              (_ctx.loadDownload)
                ? (_openBlock(), _createElementBlock("div", _hoisted_27, _hoisted_29))
                : (_openBlock(), _createElementBlock("svg", _hoisted_30, _hoisted_32)),
              _createTextVNode(" " + _toDisplayString(!_ctx.loadDownload ? 'Baixar' : 'Baixando'), 1)
            ], 8, _hoisted_26)
          ])
        ])
      ])
    ])
  ]))
}